import React from "react";

const PaperClip = (props) => {
  const _width = props.width || 24;
  return (
    <svg
      id="icon-paper-clip"
      xmlns="http://www.w3.org/2000/svg"
      data-name="icon-paper-clip"
      viewBox="0 0 24 24"
      width={_width}
      {...props}
    >
      <path d="M19,4v13c0,3.86-3.14,7-7,7s-7-3.14-7-7V5C5,2.24,7.24,0,10,0s5,2.24,5,5v12c0,1.65-1.35,3-3,3s-3-1.35-3-3V6c0-.55,.45-1,1-1s1,.45,1,1v11c0,.55,.45,1,1,1s1-.45,1-1V5c0-1.65-1.35-3-3-3s-3,1.35-3,3v12c0,2.76,2.24,5,5,5s5-2.24,5-5V4c0-.55,.45-1,1-1s1,.45,1,1Z" />
    </svg>
  );
};

export default PaperClip;
